import { Stack } from "@mui/material";
import { MATERIAL_REQUEST_STATUS } from "../../../../data/enums";
import { StyledNavLink } from "../../../../shared/styled/TableStyles";
import { MaterialRequestChildLinkedWrapper, MaterialRequestLinkedTitle } from "../Styled";
import Status from "../../../../shared/components/Status";
import { getStatusColorTheme } from "../../../MaterialRequests/Content/MaterialRequestTable";
import { MaterialRequestFilterType, valueToText } from "../../../../configs/filterTypes";

interface Props {
    materialRequests: {
        id: string;
        request_name: string;
        due_date: string;
        status: MATERIAL_REQUEST_STATUS;
    }[];
}

export const MaterialRequestLink = ({ materialRequests }: Props) => {
    return (
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            <MaterialRequestChildLinkedWrapper>
                <MaterialRequestLinkedTitle>Mã đơn lãnh:</MaterialRequestLinkedTitle>
                <Stack spacing={1}>
                    {materialRequests.map((item, idx) => (
                        <Stack direction="row" spacing={1}>
                            <StyledNavLink to={`/material-requests/${item.id}`} key={item.id}>
                                {item.request_name}
                            </StyledNavLink>
                            <Status
                                colorTheme={getStatusColorTheme(item.status)}
                                text={valueToText(MaterialRequestFilterType, "status", item.status)}
                                width="124px"
                            />
                        </Stack>
                    ))}
                </Stack>
            </MaterialRequestChildLinkedWrapper>
        </div>
    );
};
